import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { AMBankProperties, useAMBankProperties } from "./AMBankProperties";

import { DraftAMBankButtonComponent } from "./DraftAMBankButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";
import { AMBankButton } from "./AMBankButton";

export const AMBankButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useAMBankProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <AMBankButton {...properties}
            className={className}>
            {children}
        </AMBankButton>
    )
}

Registry.addControl({
    id: "5a26aced-5816-4a13-afb4-48644381f3c8",
    name: "AM-Bank Button",
    type: ControlType.AMBankButton,
    properties: AMBankProperties,
    component: AMBankButtonComponent,
    draftComponent: DraftAMBankButtonComponent
})
